import { render, staticRenderFns } from "./NewsWidget.vue?vue&type=template&id=c19a67b6&scoped=true&"
import script from "./NewsWidget.vue?vue&type=script&lang=ts&"
export * from "./NewsWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19a67b6",
  null
  
)

export default component.exports